/**
 * 書庫頁的快捷鍵。
 *
 * 形狀與閱讀器那一套相同：一張表加一個查表函式，而「焦點在文字輸入或對話框內時不作用」
 * 直接重用閱讀器的判斷，不另寫一份——那個判斷寫錯的後果是在搜尋框打字會觸發全選。
 */

export type LibraryAction = 'select-all' | 'exit-selection'

export type LibraryShortcut = { action: LibraryAction; preventDefault: boolean }

/**
 * 多選模式下的按鍵對應。
 *
 * 全選用作業系統既有的習慣並抑制瀏覽器自己的全選；離開用 Escape。兩者都只在多選模式下
 * 作用——書庫頁沒有閱讀器那種「整頁都是內容」的前提，單一字母鍵在未來加入任何輸入框時
 * 都可能撞車，因此不用。
 */
export function libraryShortcut(
  key: string,
  modifiers: { ctrl?: boolean; meta?: boolean; alt?: boolean; shift?: boolean } = {},
  selecting = false,
): LibraryShortcut | null {
  if (!selecting || modifiers.alt) return null
  if (key === 'Escape' && !modifiers.ctrl && !modifiers.meta && !modifiers.shift) {
    return { action: 'exit-selection', preventDefault: false }
  }
  if (key.toLowerCase() === 'a' && (modifiers.ctrl || modifiers.meta) && !modifiers.shift) {
    return { action: 'select-all', preventDefault: true }
  }
  return null
}

/** 畫面上顯示的按鍵字樣。Mac 顯示 ⌘，其餘顯示 Ctrl。 */
export function selectAllKeyLabel(platform = globalThis.navigator?.platform ?? ''): string {
  return /mac|iphone|ipad/i.test(platform) ? '⌘A' : 'Ctrl+A'
}
